/**
 * @generated SignedSource<<2461cee90e82ddb598f1da027fc6476e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateCustomMcpServerInput = {
  authType: string;
  credentials?: string | null | undefined;
  description?: string | null | undefined;
  name: string;
  returnPath?: string | null | undefined;
  url: string;
};
export type CreateMcpServerRouteCreateMutation$variables = {
  input: CreateCustomMcpServerInput;
};
export type CreateMcpServerRouteCreateMutation$data = {
  readonly createCustomMcpServer: {
    readonly error: string | null | undefined;
    readonly oauthUrl: string | null | undefined;
    readonly server: {
      readonly authType: string;
      readonly description: string | null | undefined;
      readonly discoveredTools: ReadonlyArray<string>;
      readonly id: any;
      readonly isActive: boolean;
      readonly name: string;
      readonly toolCount: number;
      readonly url: string;
    } | null | undefined;
  };
};
export type CreateMcpServerRouteCreateMutation = {
  response: CreateMcpServerRouteCreateMutation$data;
  variables: CreateMcpServerRouteCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomMcpServerPayload",
    "kind": "LinkedField",
    "name": "createCustomMcpServer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCustomMcpServer",
        "kind": "LinkedField",
        "name": "server",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discoveredTools",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oauthUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMcpServerRouteCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateMcpServerRouteCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "be00484bc33813adca407359ce7c8b56",
    "id": null,
    "metadata": {},
    "name": "CreateMcpServerRouteCreateMutation",
    "operationKind": "mutation",
    "text": "mutation CreateMcpServerRouteCreateMutation(\n  $input: CreateCustomMcpServerInput!\n) {\n  createCustomMcpServer(input: $input) {\n    server {\n      id\n      name\n      description\n      url\n      authType\n      isActive\n      discoveredTools\n      toolCount\n    }\n    error\n    oauthUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0707296afcb4fea8c7f14da7ba680ec";

export default node;
